__turbopack_context__.v({
  "dots": "Background-module-scss-module__N7VgTa__dots",
  "gradient": "Background-module-scss-module__N7VgTa__gradient",
  "mask": "Background-module-scss-module__N7VgTa__mask",
});
